module.exports = __webpack_public_path__ + "img/7_136.0381afaa.png";